import { useCallback, useEffect, useRef } from 'react';
import { getUserInfo } from '../utils';
import stompWebsocket from './stompWebsocket';
const isEmpty = (obj) => Object.keys(obj || {}).length === 0;
export function useWebSocket(config) {
    const { start, inboxList, onSuccess, onWebSocketConnected, mode, authLoginType, } = config;
    const websocketInfo = useRef({
        status: 'ready',
        userId: '',
        companyId: '',
        socket: null,
    });
    const startWsHandler = useCallback(() => {
        const currentUser = getUserInfo();
        if (currentUser?.id &&
            isEmpty(websocketInfo.current.socket) &&
            websocketInfo.current.status !== 'connection' &&
            start !== false) {
            try {
                websocketInfo.current.status = 'connection';
                const websocketParams = {
                    inboxList,
                    receiveMessage: (data, resData) => {
                        // websocket回调操作
                        if (data.socketConnectStatus == 'success') {
                            websocketInfo.current = {
                                ...websocketInfo.current,
                                socket: resData.target,
                                status: 'done',
                            };
                            onWebSocketConnected?.({
                                ...stompWebsocket,
                                updateTimer: new Date().getTime(),
                            });
                        }
                        // receiveMessage?.(data, resData);
                        onSuccess?.(data, resData);
                    },
                };
                stompWebsocket.initSocket(websocketParams, websocketParams.inboxList, undefined, mode, authLoginType);
            }
            catch (error) {
                websocketInfo.current = {
                    ...websocketInfo.current,
                    status: 'ready',
                };
            }
        }
        else {
            websocketInfo.current = {
                ...websocketInfo.current,
                status: 'ready',
            };
        }
    }, []);
    useEffect(() => {
        const currentUser = getUserInfo();
        // 有登录信息, 建立websocket连接
        startWsHandler();
        // 监听用户信息的变化
        function onStorangeChange() {
            let newUser = sessionStorage.getItem('USER_INFO') || '';
            if (newUser) {
                newUser = JSON.parse(newUser) || {};
            }
            if (newUser.defaultCompId != currentUser.defaultCompId) {
                startWsHandler();
            }
        }
        window.addEventListener('storage', onStorangeChange);
        return window.removeEventListener('storage', onStorangeChange);
    }, []);
    return {
        startWsHandler,
    };
}
